import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiService } from '../../../app/services/api.service';
import { OrderDataSourceConfig } from '../interfaces/order-data-source-config';
import { OrderDataSource } from './order-data-source';

@Injectable()
export class OrderApiService {
  constructor(protected Api: ApiService) {}

  public list(eventId: number, pageIndex = 0) {
    return this.Api.getWithoutPageEventFilter(
      'event-admin/event-guest-list/event-id/' + eventId,
      { pageIndex },
      environment.eventAdminUrl
    );
  }

  public getDataSource(DataSourceConfig: OrderDataSourceConfig) {
    return new OrderDataSource(this);
  }

  public handleError(error: unknown) {
    return this.Api.handleError(error);
  }

  public notes(id: string, notes: string) {
    return this.Api.patch(
      'event-admin/update-order-notes/order-id/' + id,
      { notes: notes },
      environment.eventAdminUrl
    )
      .then(() => this.Api.handleSuccess(id + ' notes saved.'))
      .catch((error) => this.Api.handleError(error));
  }

  public refund(id: string, notes: string) {
    return this.Api.patch(
      'event-admin/refund-order/order-id/' + id,
      { notes: notes },
      environment.eventAdminUrl
    )
      .then(() => this.Api.handleSuccess('Order ' + id + ' refunded'))
      .catch((error) => this.Api.handleError(error));
  }

  // public list(role: string, ticketId: number) {
  //   const endpoint = environment.endpoint[role].orders(ticketId);

  //   return this.Api.get(endpoint).then((Orders: Order[]) => Orders);
  // }

  // public ticket(role: string, listingId: number, Order: any) {
  //   const endpoint = environment.endpoint[role].orders(listingId, Order.id);

  //   return this.Api.put(`${endpoint}/ticket`, Order)
  //     .then(() => this.Api.handleSuccess('ticket saved'))
  //     .catch(error => this.Api.handleError(error));
  // }
}
